import axios from '@/api/requests/axios'

const append = (formData, key, value) => {
  if (value === null || value === undefined || value === '') {
    return
  }

  formData.append(key, value)
}

const buildFormData = (promotion, image) => {
  const formData = new FormData()

  append(formData, 'image', image)
  append(formData, 'id', promotion.id)
  append(formData, 'sortIndex', promotion.sortIndex)
  append(formData, 'isBanner', promotion.isBanner)

  for (let i = 0; i < promotion.contacts.length; i++) {
    append(formData, `contacts[${i}]`, promotion.contacts[i])
  }

  for (let i = 0; i < promotion.translations.length; i++) {
    append(formData, `translations[${i}].language`, promotion.translations[i].language)
    append(formData, `translations[${i}].name`, promotion.translations[i].name)
    append(formData, `translations[${i}].subtitle`, promotion.translations[i].subtitle)
    append(formData, `translations[${i}].description`, promotion.translations[i].description)
  }

  append(formData, 'dateFrom', promotion.dateRange.start)
  append(formData, 'dateTo', promotion.dateRange.end)

  return formData
}

export default {
  getAll: params => axios.get('/api/admin/v1/promotions', { params }),
  getById: id => axios.get(`/api/admin/v1/promotions/${id}`),
  create: (promotion, image) => axios.post('/api/admin/v1/promotions', buildFormData(promotion, image)),
  update: (promotion, image) => axios.put('/api/admin/v1/promotions', buildFormData(promotion, image)),
  delete: id => axios.delete(`/api/admin/v1/promotions/${id}`),
}
